import React, { useState } from 'react';
import {
  TableCell,
  TableRow,
  makeStyles,
} from '@material-ui/core';
import styles from '../../../../styles/loadboard.module.scss';
import { getTimeDiff } from '@jumbo/utils/commonHelper';
import { useLocation } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { useDispatch, useSelector } from 'react-redux';
import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles(theme => ({
  titleRoot: {
    marginBottom: 2,
    fontSize: 14,
    letterSpacing: 0.25,
    color: theme.palette.common.dark,
  },
  chipRoot: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)',
    borderRadius: 4,
    marginRight: 10,
    marginBottom: 12,
    height: 26,
    fontSize: 14,
    color: theme.palette.text.secondary,
    cursor: 'pointer',
  },
  root: {
    width: 500,
  },
}));

const LoadsListShimmer = ({
  row,
  currentLoadFilter,
  itemIndex
}) => {
  const classes = useStyles();

  const [open, setOpen] = useState(false);

  const [currentIndex, setCurrentIndex] = useState(null);

  const location = useLocation();

  console.log (currentIndex == itemIndex)

  return (
    <React.Fragment>
      <TableRow
        className={styles.dailyLoadsTableHeader + ' ' + styles.shimmerDailyLoadsTableHeader} 
        hover
        tabIndex={-1}
        style={{
          cursor: 'pointer',
          display: 'table',
          width: '100%'
        }}>
        {location.pathname == '/workbook/bookings' ? (
          <React.Fragment>
            <TableCell> <Skeleton variant="text" /></TableCell>
            {row.source != 'LoadBoard123' ? (
              <TableCell>  <Skeleton variant="text" /></TableCell>
            ) : (
              '-'
            )}
            <TableCell>
              {row.owner_operator?.name ? `${row.owner_operator?.name} ` : '-'}
              <span> <Skeleton variant="text" /></span>
            </TableCell>
            <TableCell>
              {row.driver?.name ? `${row.driver?.name} ` : '-'}
              <span> <Skeleton variant="text" /></span>
            </TableCell>
          </React.Fragment>
        ) : (
          ''
        )}
        {location.pathname != '/workbook/bookings'? <TableCell><Skeleton variant="text" /></TableCell> : ''}
        <TableCell>
          <Skeleton variant="text" />
          {
             location.pathname == '/loads/user-interests' || location.pathname == '/workbook/requests'?
             ''
             :
             <span
            style={{
              fontSize: '12px',
              color:
                currentLoadFilter && currentLoadFilter.dho && parseInt(currentLoadFilter.dho) < parseInt(row.distance_origin)
                  ? 'red'
                  : 'black',
            }}>
             <Skeleton variant="text" width="60%"/>
          </span>
          }
        </TableCell>
        <TableCell>
            <Skeleton variant="text" /> 
          {
            location.pathname == '/loads/user-interests' || location.pathname == '/workbook/requests' ?
            ''
            :
            <span
            style={{
              fontSize: '12px',
              color:
                currentLoadFilter &&
                currentLoadFilter.dhd &&
                parseInt(currentLoadFilter.dhd) < parseInt(row.distance_destination)
                  ? 'red'
                  : 'black',
            }}>
            <Skeleton variant="text" width="60%"/>
          </span>
          }
        </TableCell>
        <TableCell> <Skeleton variant="text" /></TableCell>
        {location.pathname != '/workbook/bookings' ? (
          <TableCell> <Skeleton variant="text" /></TableCell>
        ) : (
          ''
        )}
        {/* <TableCell>{row.rate_per_mile != '0' ? `$${row.rate_per_mile}` : '-'}</TableCell> */}
        {location.pathname != '/workbook/requests' ? (
          <TableCell>
            <Skeleton variant="text" />
          </TableCell>
        ) : (
          ''
        )}
        {location.pathname == '/loads/user-interests' || location.pathname == '/workbook/requests' ? (
          <TableCell>
          
            {row.users?.length ? (
              <p className={styles.interestedUserInfo}>
                <Tooltip title={row.users[0].phone || '-'} placement="top-start" className={classes.root} arrow>
                  <span> <Skeleton variant="text" /></span>
                </Tooltip>
              </p>
            ) : (
              '-'
            )}
          </TableCell>
        ) : (
          ''
        )}
        <TableCell>
            <Skeleton variant="text" /> 
          <span style={{ fontSize: '12px', textTransform: 'lowercase' }}>
            <Skeleton variant="text" width="60%" />   
          </span>
        </TableCell>
        {location.pathname != '/workbook/bookings' ? (
          <TableCell><Skeleton variant="text" /></TableCell>
        ) : (
          ''
        )}
     
        <TableCell
            align="center"
            style={{ textAlign: 'left', whiteSpace: 'nowrap' }}
        >
            <Skeleton variant="text" />
            <Skeleton variant="text" />
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

export default React.memo(LoadsListShimmer);
